// Include the following lines to define the gtag() function when
// calling this code prior to your gtag.js or Tag Manager snippet
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

// Call the default command before gtag.js or Tag Manager runs to
// adjust how the tags operate when they run. Modify the defaults
// per your business requirements and prior consent granted/denied, e.g.:
gtag('consent', 'default', {
  'ad_storage': 'denied',
  'analytics_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied'
});

var config = {
  "apiKey": "589a3a9749780e6a4993be6a8daa9b8f0738c47b",
  "product": "COMMUNITY",
  mode: "GDPR",
  text: {
    intro: "We use cookies to enable certain functionality, understand how our website is used and for targeted advertising purposes.  These cookies may be read by third parties and other websites you visit.  We also share information about your use of our website with our analytics partners.",
    acceptRecommended: 'Accept all cookies',
    rejectSettings: 'Reject all cookies'

  },
  closeStyle: 'button',
  rejectButton: true,
  acceptBehaviour: "recommended",
  statement: {
    description: "For more information, please see our ",
    name: "cookie policy.",
    url: "/cookie-policy",
    updated: "29/07/2020",
  },
  necessaryCookies: [
    'CRAFT_CSRF_TOKEN', 
    'CraftSessionId', 
    '_hjid', 
    'visid_incap',
    'JSESSIONID',
    'NEXT_LOCALE',
    '_last_auth_user',
    'access_token',
    'cf_clearance',
    'csrftoken',
    '__cfruid',

  ],
  optionalCookies: [
    {
      name : 'analytics',
      label: 'Analytical Cookies',
      description: 'Analytical cookies help us to improve our website by collecting and reporting information on its usage.',
      cookies: [        
        '_ga',
        '_ga*',
        '_gid',
        '_gat',
        '_gali',
        '__utma',
        '__utmt',
        '__utmb',
        '__utmc',
        '__utmz',
        '__utmv',
        '_hjIncludedInSessionSample',
        '_hjSessionUser',
        '_hjSessionUser_*',
        '_hjAbsoluteSessionInProgress',
        '_hjSession', 
        '_hjSession_*', 
        '_hjFirstSeen',
        'CrosstabGlobal',
        'VISITOR_INFO1_LIVE',
        'VISITOR_PRIVACY_METADATA',
        'YSC',
        '_ALGOLIA',
        '_BEAMER_USER_ID_*',
        'ajs_anonymous_id',
        'ajs_user_id',
        'DV',
        'IDE',
        'OTZ',
        'SNID',
        '__Secure-ENID',
        'AEC',
        'NID',
        'SOCS',
        '_hjHasCachedUserAttributes',
        'hjLIStatus',
    ],
      onAccept: function(){
        gtag('consent', 'update', {'analytics_storage': 'granted'});
      },
      onRevoke: function(){
        gtag('consent', 'update', {'analytics_storage': 'denied'});
      },
      recommendedState: true,
      lawfulBasis: "consent",
    }, 
  ],
  layout:'slideout',
  position: "RIGHT",
  theme: "light",
  "iabCMP": false,
  rejectButton: false,
  notifyDismissButton: false,

};

CookieControl.load( config );